import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AppLayout from '../components/layout/AppLayout';

const AdminPage = lazy(() => import('../pages/admin/AdminPage'));
const DashboardPage = lazy(() => import('../pages/dashboard/DashboardPage'));
const HomePage = lazy(() => import('../pages/home/HomePage'));
const NotFoundPage = lazy(() => import('../pages/not-found/NotFoundPage'));
const ProductDetailPage = lazy(() => import('../pages/products/ProductDetailPage'));
const ProductsPage = lazy(() => import('../pages/products/ProductsPage'));
const ProfilePage = lazy(() => import('../pages/profile/ProfilePage'));

function RouteFallback() {
  return (
    <div className="status-panel">
      <div className="status-spinner" />
      <h2>Cargando vista...</h2>
      <p>Estamos preparando esta sección.</p>
    </div>
  );
}

function AppRouter() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route element={<AppLayout />} path="/">
          <Route element={<HomePage />} index />
          <Route element={<ProductsPage />} path="productos" />
          <Route element={<ProductDetailPage />} path="productos/:productId" />
          <Route element={<ProfilePage />} path="perfil" />
          <Route element={<DashboardPage />} path="dashboard" />
          <Route element={<AdminPage />} path="admin" />
          <Route element={<Navigate replace to="/" />} path="home" />
          <Route element={<NotFoundPage />} path="*" />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default AppRouter;
